(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Transaction.Capture.Finances.Edit",
                {
                    url: "/{financeType}/Edit",
                    component: "editFinances",
                    resolve: {
                        financeType: ["$transition$", function ($transition$) {
                            return $transition$.params().financeType;
                        }]
                    }
                });
        }
    ]);

    app.component("editFinances",
        {
            templateUrl: "/App/Transaction/Capture/Finances/EditFinances/editfinances-template.html",
            controller: editFinancesController,
            bindings: {
                transaction: "<",
                finance: "<",
                otherMonthlyIncomes: "<",
                otherMonthlyExpenses: "<",
                otherAssets: "<",
                otherLiabilities: "<",
                financeType: "<"
            }
        });

    editFinancesController.$inject = ["_", "$q", "financeApi"];
    function editFinancesController(_, $q, financeApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                    Saving: false
                },
                total: 0,
                updateFinance: updateFinance,
                addOtherFinance: addOtherFinance,
                updateOtherFinance: updateOtherFinance,
                removeOtherFinance: removeOtherFinance
            });

        function updateFinance() {
            var promises = [];

            if (!$ctrl.finance)
                $ctrl.finance = {};
            if (!$ctrl.finance.Id) {
                $ctrl.finance.TransactionId = $ctrl.transaction.Id;
                promises.push(financeApi.add($ctrl.transaction.Id, $ctrl.finance).then(function (response) {
                    $ctrl.finance.Id = response.Id;
                }));
            }

            $q.all(promises).then(function () {
                switch ($ctrl.financeType) {
                    case "MonthlyIncome":
                        financeApi.updateMonthlyIncomes($ctrl.finance.Id, $ctrl.finance).then(function () {
                            calculateTotal();
                        });
                        break;
                    case "MonthlyExpense":
                        financeApi.updateMonthlyExpenses($ctrl.finance.Id, $ctrl.finance).then(function () {
                            calculateTotal();
                        });
                        break;
                    case "Asset":
                        financeApi.updateAssets($ctrl.finance.Id, $ctrl.finance).then(function () {
                            calculateTotal();
                        });
                        break;
                    case "Liability":
                        financeApi.updateLiabilities($ctrl.finance.Id, $ctrl.finance).then(function () {
                            calculateTotal();
                        });
                        break;
                }
            });
        }

        function addOtherFinance(otherFinance, otherFinanceList) {
            $ctrl.ui.Saving = true;
            var promises = [];

            if (!$ctrl.finance || !$ctrl.finance.Id) {
                $ctrl.finance.TransactionId = $ctrl.transaction.Id;
                promises.push(financeApi.add($ctrl.transaction.Id, $ctrl.finance).then(function (response) {
                    $ctrl.finance.Id = response.Id;
                }));
            }

            $q.all(promises).then(function () {
                financeApi.addOtherFinance($ctrl.finance.Id, otherFinance).then(function (response) {
                    otherFinance.Id = response.Id;
                    otherFinanceList.push(otherFinance);
                    $ctrl.ui.Saving = false;
                    $ctrl.newFinanceName = null;
                    calculateTotal();
                });
            });
        }

        function updateOtherFinance(otherFinance) {
            financeApi.updateOtherFinance($ctrl.finance.Id, otherFinance.Id, otherFinance).then(function () {
                calculateTotal();
            });
        }

        function removeOtherFinance(otherFinance, otherFinanceList, index) {
            otherFinanceList.splice(index, 1);
            financeApi.deleteOtherFinance($ctrl.finance.Id, otherFinance.Id);
        }

        function calculateTotal() {
            $ctrl.total = 0;
            if ($ctrl.finance) {
                switch ($ctrl.financeType) {
                    case "MonthlyIncome":
                        ng.forEach($ctrl.finance.MonthlyIncomes,
                            function (income) {
                                if (income)
                                    $ctrl.total += parseFloat(income);
                            });
                        ng.forEach($ctrl.otherMonthlyIncomes,
                            function (income) {
                                if (income.Value)
                                    $ctrl.total += parseFloat(income.Value);
                            });
                        break;
                    case "MonthlyExpense":
                        ng.forEach($ctrl.finance.MonthlyExpenses,
                            function (expense) {
                                if (expense)
                                    $ctrl.total += parseFloat(expense);
                            });
                        ng.forEach($ctrl.otherMonthlyExpenses,
                            function (expense) {
                                if (expense.Value)
                                    $ctrl.total += parseFloat(expense.Value);
                            });
                        break;
                    case "Asset":
                        ng.forEach($ctrl.finance.Assets,
                            function (asset) {
                                if (asset)
                                    $ctrl.total += parseFloat(asset);
                            });
                        ng.forEach($ctrl.otherAssets,
                            function (asset) {
                                if (asset.Value)
                                    $ctrl.total += parseFloat(asset.Value);
                            });
                        break;
                    case "Liability":
                        ng.forEach($ctrl.finance.Liabilities,
                            function (liability) {
                                if (liability)
                                    $ctrl.total += parseFloat(liability);
                            });
                        ng.forEach($ctrl.otherLiabilities,
                            function (liability) {
                                if (liability.Value)
                                    $ctrl.total += parseFloat(liability.Value);
                            });
                        break;
                }
            }

            $ctrl.total = $ctrl.total.toFixed(2);
        }

        this.$onInit = function() {
            calculateTotal();
        };
    }

})(window.app, window.angular); //jshint ignore:line